var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mt-8 text-sm leading-loose text-center text-gray-600 lg:text-base lg:leading-loose"},[_vm._v("\n    Join over 1,000,000 people who saved up to 80%"),_c('br',{staticClass:"hidden sm:block"}),_vm._v(" on lawyer fees with Unbundled Legal\n    Help\n")])
}]

export { render, staticRenderFns }